import React from 'react';
import { Typography } from '@mui/material';

const Legend = () => {
  return (
    <div style={{
      padding: '8px',
      position: 'absolute',
      bottom: '40px',
      right: '20px',
      backgroundColor: 'white',
      borderRadius: '4px',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)',
      zIndex: 1000,
      maxWidth: '180px',
      fontSize: '0.8rem'
    }}>
      <Typography variant="body2" align="left" gutterBottom>
        Election Results
      </Typography>

      <div style={{ marginBottom: '4px', display: 'flex', alignItems: 'center' }}>
        <div style={{
          height: '12px',
          width: '24px',
          background: '#9191f0',
          borderRadius: '3px',
          marginRight: '8px'
        }}></div>
        <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.7rem' }}>
          Democratic Victory
        </Typography>
      </div>

      <div style={{ marginBottom: '4px', display: 'flex', alignItems: 'center' }}>
        <div style={{
          height: '12px',
          width: '24px',
          background: '#ea9794',
          borderRadius: '3px',
          marginRight: '8px'
        }}></div>
        <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.7rem' }}>
          Republican Victory
        </Typography>
      </div>
    </div>
  );
};

export default Legend;